import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Header from '../components/Header';
import FormTaxDetails from '../containers/FormTaxDetails';
import FormShopsAndRates from '../containers/FormShopsAndRates';
import FormProducts from '../containers/FormProducts';
import FormServices from '../containers/FormServices';
import { ProductTaxAssigment, ServicesTaxAssigment } from '../../../../../modules/brand/taxes/products-and-services';
import { TaxShopAssignments } from '../../../../../modules/brand/taxes/shop-assignmetns';

const TABS = [
  FormTaxDetails, FormShopsAndRates, FormProducts, FormServices,
];

const TABS_V2 = [
  FormTaxDetails, TaxShopAssignments, ProductTaxAssigment, ServicesTaxAssigment,
];

const FormWrapper = (props) => {
  const { page, setPage, edit, isBrandUser } = props;

  const TabList = props.brandTaxAutoSave ? TABS_V2 : TABS;
  const TabComponent = get(TabList, page);

  return (
    <div className="c-wrapper">
      <div className="u-max-width-710 u-margin-auto">
        {isBrandUser && (
          <Header
            page={page}
            setPage={setPage}
            edit={edit}
          />
        )}
        <TabComponent {...props} />
      </div>
    </div>
  );
};

FormWrapper.propTypes = {
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  isBrandUser: PropTypes.bool,
  brandTaxAutoSave: PropTypes.bool.isRequired,
};

FormWrapper.defaultProps = {
  isBrandUser: false,
  edit: false,
};

export default FormWrapper;
